// extracted by mini-css-extract-plugin
export var actionIcon = "_ts-0";